import React from "react";
import Groupicon from "../../assets/images/Group.png";

const Upload = ({data}) => {
  return (
    <div className="block upload" key={data.name}>
      <div className="uploading">
        <svg width="100" height="80" viewBox="0 -10 40 60">
          <circle
            cx="20"
            cy="20"
            r="18"
            fill="none"
            stroke="#e6e6e6"
            stroke-width="2"
          />
          <circle
            className="percent fifty"
            cx="20"
            cy="20"
            r="18"
            fill="none"
            stroke="#D22F26"
            stroke-width="2"
            pathLength="100"
            style={{
              transition: "all 0.3s",
              strokeDasharray: 100,
              strokeDashoffset: `calc(100 - ${data?.newUpload?.percentage})`,
            }}
          />
        </svg>
        <div className="percentage">
          {data?.newUpload?.percentage}
          <span>%</span>
        </div>
      </div>
      <div className="img-block ">
        <img src={Groupicon} alt="" />
      </div>
      <div className="text-block">
        <label>{data?.newUpload?.name}</label>
      </div>
    </div>
  );
};

export default Upload;
